import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Leaf } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-gradient-to-b from-cream to-warm-deep/30" data-id="element-77">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-40" data-id="element-78">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold/10 blur-3xl" data-id="element-79" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-sage/10 blur-3xl" data-id="element-80" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-8 w-full" data-id="element-81">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-82">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-83">
            <FadeIn delay={0.1} data-id="element-84">
              <div className="flex items-center gap-2 mb-6 text-sage" data-id="element-85">
                <Leaf size={18} className="opacity-80" data-id="element-86" />
                <span className="text-sm font-medium tracking-widest uppercase" data-id="element-87">
                  Un camino hacia la paz
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-88">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-brown" data-id="element-89">
                DE CAOS A{' '}
                <span className="text-gold italic font-light" data-id="element-90">CALMA</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-91">
              <h2 className="text-2xl md:text-3xl font-medium text-brown-light mb-6 leading-snug" data-id="element-92">
                El Método de 30 Días para Madres que Sostienen el Mundo Solas
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-93">
              <p className="text-lg md:text-xl text-brown/80 leading-relaxed mb-10 border-l-4 border-gold/30 pl-6 py-2" data-id="element-94">
                Reprograma tu ansiedad, recupera tu energía y vuelve a ser tú
                <span className="block mt-2 font-medium text-brown-light" data-id="element-95">
                  (Incluso con TDAH y sin red de apoyo).
                </span>
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-96">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-gold hover:bg-gold-dark text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-lg shadow-gold/20 hover:shadow-xl hover:shadow-gold/30 hover:-translate-y-1 w-full sm:w-auto" data-id="element-97">
                Comienza tu viaje hoy
              </button>
            </FadeIn>
          </div>

          {/* Image Content */}
          <FadeIn delay={0.4} direction="left" className="relative lg:h-[600px] flex justify-center items-center" data-id="element-98">
            <motion.div className="relative w-full max-w-md lg:max-w-full" animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-99">
              {/* Decorative glow behind image */}
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full scale-90 -z-10" data-id="element-100" />

              <img src="https://cdn.magicpatterns.com/uploads/5CGgkmwMoWn4AChkESpcuT/mockup_.png" alt="De Caos a Calma - Bundle de productos digitales" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-101" />
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}